import { render, staticRenderFns } from "./TipoDato.view.vue?vue&type=template&id=0a25d610"
import script from "./TipoDato.view.vue?vue&type=script&lang=js"
export * from "./TipoDato.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports